export default __webpack_public_path__ + "static/media/page-break.5ea03938.svg";